import React, { useContext } from "react";
import { VideoContext } from "../context/VideoContext";

// Define an array of colors for different card backgrounds
const cardColors = ["#FF5733", "#33FF57", "#3357FF", "#FF33A6", "#FFC733", "#33FFF3"];

// Function to get YouTube thumbnail from video ID
const getYouTubeThumbnail = (videoId) => {
  return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
};

const ScrollingCards = () => {
  const { leftVideoIds, rightVideoIds } = useContext(VideoContext);
  return (
    <>
      {/* Left Side Scrolling Cards */}
      <div className="scrolling-cards-container scrolling-cards-left">
        <div className="scrolling-wrapper">
          {leftVideoIds.map((videoId, index) => (
            <div key={index} className="scrolling-card" 
                 style={{ backgroundColor: cardColors[index % cardColors.length] }}>
              <a href={`https://www.youtube.com/watch?v=${videoId}`} target="_blank" rel="noopener noreferrer">
                <div className="card-content">
                  <img src={getYouTubeThumbnail(videoId)} alt="YouTube Thumbnail" className="thumbnail" />
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Right Side Scrolling Cards */}
      <div className="scrolling-cards-container scrolling-cards-right">
        <div className="scrolling-wrapper">
          {rightVideoIds.map((videoId, index) => (
            <div key={index} className="scrolling-card" 
                 style={{ backgroundColor: cardColors[index % cardColors.length] }}>
              <a href={`https://www.youtube.com/watch?v=${videoId}`} target="_blank" rel="noopener noreferrer">
                <div className="card-content">
                  <img src={getYouTubeThumbnail(videoId)} alt="YouTube Thumbnail" className="thumbnail" />
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ScrollingCards;
